import { SfSelectFormField, SfSelectOption } from 'ngx-smart-form';

export enum ModalitaIdentificazioneEnum {
  IN_PRESENZA = 'IN_PRESENZA',
  DA_ATTO_PUBBLICO = 'DA_ATTO_PUBBLICO',
  DA_SCRITTURA_PRIVATA_AUTENTICATA = 'DA_SCRITTURA_PRIVATA_AUTENTICATA',
  DA_CERTIFICATI_QUALIFICATI = 'DA_CERTIFICATI_QUALIFICATI',
  DA_DICHIARAZIONE_DELL_AUTORITA_CONSOLARE = 'DA_DICHIARAZIONE_DELL_AUTORITA_CONSOLARE',
  PER_ALTRO_RAPPORTO = 'PER_ALTRO_RAPPORTO',
  A_DISTANZA = 'A_DISTANZA',
}

export const getModalitaIdentificazioneOptions = () => {
  const options: SfSelectOption<ModalitaIdentificazioneEnum>[] = [
    {
      value: ModalitaIdentificazioneEnum.IN_PRESENZA,
      view: 'DIRETTA IN PRESENZA',
    },
    {
      value: ModalitaIdentificazioneEnum.DA_ATTO_PUBBLICO,
      view: 'DIRETTA DA ATTO PUBBLICO',
    },
    {
      value: ModalitaIdentificazioneEnum.DA_SCRITTURA_PRIVATA_AUTENTICATA,
      view: 'DIRETTA DA SCRITTURA PRIVATA AUTENTICATA',
    },
    {
      value: ModalitaIdentificazioneEnum.DA_CERTIFICATI_QUALIFICATI,
      view: 'DIRETTA DA CERTIFICATI QUALIFICATI',
    },
    {
      value:
        ModalitaIdentificazioneEnum.DA_DICHIARAZIONE_DELL_AUTORITA_CONSOLARE,
      view: "DIRETTA DA DICHIARAZIONE DELL'AUTORITÀ CONSOLARE",
    },
    {
      value: ModalitaIdentificazioneEnum.PER_ALTRO_RAPPORTO,
      view: 'DIRETTA PER ALTRO RAPPORTO',
    },
    {
      value: ModalitaIdentificazioneEnum.A_DISTANZA,
      view: 'A DISTANZA (TRAMITE INVIO RACCOMANDATA A DOMICILIO)',
    },
  ];

  return options;
};
